import React, { useState } from 'react';
import { Field, Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { FormHelperText } from '@material-ui/core';
import isEmpty from 'lodash';

import { BaseFormProps, ErrorObject, SignUpPortalUserProps } from '@project/types';
import { Button, FormTextField } from '@project/components';

export const AddPortalUserForm: React.FC<BaseFormProps<SignUpPortalUserProps>> = ({
  initialValues,
  submitForm,
  onSuccessWithResponse,
}) => {
  const [generalError, setGeneralError] = useState(null);
  const _handleFormSubmitError = (
    error: ErrorObject,
    actions: FormikHelpers<SignUpPortalUserProps>,
  ) => {
    actions.setSubmitting(false);
    const apiErrors = error.errors;
    if (!isEmpty(apiErrors)) {
      actions.setFieldError('email', apiErrors.DuplicateEmail);
    }
    setGeneralError(error.detail);
  };

  const _handleSubmission = (
    formData: SignUpPortalUserProps,
    actions: FormikHelpers<SignUpPortalUserProps>,
  ) => {
    submitForm(formData)
      .then((data) => {
        onSuccessWithResponse(data);
      })
      .catch((error: ErrorObject) => {
        _handleFormSubmitError(error, actions);
      })
      .finally(() => actions.setSubmitting(false));
  };
  const AddPortalUserSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is Required'),
    lastName: Yup.string().required('Last Name is Required'),
    email: Yup.string().email().required('Email is Required'),
    cellPhoneNumber: Yup.string()
      .length(10, 'Phone number should be 10 characters long ')
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        'Phone number is not valid',
      )
      .required('Phone Number is required'),
  });

  return (
    <>
      <Formik
        initialValues={initialValues}
        validateOnBlur
        validateOnChange={false}
        onSubmit={_handleSubmission}
        enableReinitialize
        validationSchema={AddPortalUserSchema}
      >
        {({
          handleSubmit,
          isSubmitting,
          values,
          touched,
          errors,
          handleChange,
          handleBlur,
          handleReset,
        }) => (
          <form
            onReset={handleReset}
            onSubmit={handleSubmit}
            className="flex flex-auto flex-col gap-3 py-3 mx-7"
          >
            <p className="flex justify-center auth-heading text-center">Add New User</p>
            {generalError && <FormHelperText error>{generalError}</FormHelperText>}

            <p className="flex justify-start text-left text-xs">First Name :</p>
            <FormTextField
              variableName="firstName"
              placeholder="First Name"
              values={values}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              required
              className="w-96"
            />
            <p className="flex justify-start text-left text-xs">Last Name :</p>
            <FormTextField
              variableName="lastName"
              placeholder="Last Name"
              values={values}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              required
              className="w-96"
            />
            <p className="flex justify-start text-left text-xs">Email :</p>
            <FormTextField
              variableName="email"
              placeholder="Email"
              values={values}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              required
              className="w-96"
            />
            <p className="flex justify-start text-left text-xs">Cellphone :</p>
            <FormTextField
              variableName="cellPhoneNumber"
              placeholder="Cellphone Number"
              values={values}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              required
              className="w-96"
            />
            <p className="flex justify-start text-left text-xs">Role :</p>
            <Field as="select" name="role">
              <option value="PortalUser">Portal User</option>
            </Field>

            <Button
              isLoading={isSubmitting}
              onClick={handleSubmit}
              className="w-4/5 bg-secondary hover:bg-secondary-dark text-white text-base self-center my-7"
            >
              Add User
            </Button>
          </form>
        )}
      </Formik>
    </>
  );
};
